// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { Intruder_abstract } from './../abstract/SagaSchema/Intruder_abstract';
export class Intruder extends Intruder_abstract {}
